var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCarDetailTick(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.433,
    height: 19.433,
    viewBox: "0 0 19.433 19.433",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "i1",
    d: "M13.092,3.375a9.717,9.717,0,1,0,9.717,9.717A9.715,9.715,0,0,0,13.092,3.375Zm4.975,7.031-6.246,6.274h0a.844.844,0,0,1-.542.257.818.818,0,0,1-.547-.266L8.112,14.054a.186.186,0,0,1,0-.266l.832-.832a.181.181,0,0,1,.262,0l2.074,2.074,5.7-5.741a.184.184,0,0,1,.131-.056h0a.17.17,0,0,1,.131.056l.818.846A.184.184,0,0,1,18.067,10.406Z",
    transform: "translate(-3.375 -3.375)",
    fill: "#fab700"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarDetailTick);
export default __webpack_public_path__ + "static/media/carDetailTick.0481998ca9a8fa13e9d479b4f1a686ef.svg";
export { ForwardRef as ReactComponent };